import React from "react";
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import styles from "../styles/Chart.module.css";

const usageData = [
  { month: 'Jan 2025', usage: 8 },
  { month: 'Feb 2025', usage: 10 },
  { month: 'Mar 2025', usage: 7 },
  { month: 'Apr 2025', usage: 12 },
  { month: 'May 2025', usage: 9 },
  { month: 'Jun 2025', usage: 11 },
];

const billData = [
  { category: 'Usage Charge', amount: 3000 },
  { category: 'Service Fee', amount: 1000 },
  { category: 'VAT', amount: 500 },
  { category: 'Arrears', amount: 1500 },
];

const Chart = () => {
  return (
    <div style={{ display: 'flex', gap: '20px', padding: '20px', background: "white" }}>
      {/* Line Chart: Water Usage */}
      <div style={{ width: '50%' }}>
        <h3>Water Usage Trend (m³)</h3>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={usageData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis label={{ value: 'Usage (m³)', angle: -90, position: 'insideLeft' }} />
            <Tooltip formatter={(value) => `${value} m³`} />
            <Legend />
            <Line type="monotone" dataKey="usage" stroke="#1E90FF" activeDot={{ r: 8 }} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Bar Chart: Billing Breakdown */}
      <div style={{ width: '50%' }}>
        <h3>Current Bill Breakdown (₦)</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={billData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="category" />
            <YAxis label={{ value: 'Amount (₦)', angle: -90, position: 'insideLeft' }} />
            <Tooltip formatter={(value) => `₦${value}`} />
            <Legend />
            <Bar dataKey="amount" fill="#32CD32" onClick={(data) => alert(`Details for ${data.category}: ₦${data.amount}`)} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default Chart;